import { hookstate, useHookstate } from "@hookstate/core"

export const TabName = {
  HistoryTab: 'history',
  ScanTab: 'scan',
  ManualEnterTab: 'manual'
}

const CurrentTabState = hookstate(TabName.ScanTab)

export const useCurrentTab = () => {

  const currentTab = useHookstate(CurrentTabState)

  return {
    currentTab: currentTab.get(),
    setCurrentTab: currentTab.set
  }
}
